import { Box } from '@material-ui/core'
import React from 'react'

export const BlankActions = () => (
  <Box p={1} display="block" textAlign="right" />
)
